"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotInterestedReason = exports.FeedbackEvent = void 0;
var FeedbackEvent;
(function (FeedbackEvent) {
    FeedbackEvent["OFFER_RETURNED"] = "offer_returned";
    FeedbackEvent["OFFER_SHOWN"] = "offer_shown";
    FeedbackEvent["CLIENT_NOT_INTERESTED"] = "client_not_interested";
    FeedbackEvent["CLIENT_INTERESTED"] = "client_interested";
    FeedbackEvent["OFFER_ACCEPTED"] = "offer_accepted";
    FeedbackEvent["FULFILLMENT_STARTED"] = "fulfillment_started";
    FeedbackEvent["PROSPECT_ID_KNOWN"] = "prospect_id_known";
    FeedbackEvent["CUSTOMER_ID_KNOWN"] = "customer_id_known";
    FeedbackEvent["CONTRACT_ID_KNOWN"] = "contract_id_known";
    FeedbackEvent["FULFILLMENT_STAGE_1"] = "fulfillment_stage_1";
    FeedbackEvent["FULFILLMENT_STAGE_2"] = "fulfillment_stage_2";
    FeedbackEvent["FULFILLMENT_STAGE_3"] = "fulfillment_stage_3";
    FeedbackEvent["FULFILLMENT_STAGE_4"] = "fulfillment_stage_4";
    FeedbackEvent["FULFILLMENT_CANCELLED"] = "fulfillment_cancelled";
    FeedbackEvent["COOLDOWN_STARTED"] = "cooldown_started";
    FeedbackEvent["COOLDOWN_EXPIRED"] = "cooldown_expired";
    FeedbackEvent["FULFILLMENT_COMPLETED"] = "fulfillment_completed";
})(FeedbackEvent = exports.FeedbackEvent || (exports.FeedbackEvent = {}));
var NotInterestedReason;
(function (NotInterestedReason) {
    NotInterestedReason["NOT_INTERESTED"] = "not_interested";
    NotInterestedReason["WANTS_TO_WAIT"] = "wants_to_wait";
    NotInterestedReason["HAPPY_WITH_CURRENT_SUPPLIER"] = "happy_with_current_supplier";
    NotInterestedReason["TARIFFS_TOO_HIGH"] = "tariffs_too_high";
    NotInterestedReason["PRECONDITIONS_UNMET"] = "preconditions_unmet";
    NotInterestedReason["INSTALLATION_NOT_FOUND"] = "installation_not_found";
    NotInterestedReason["USED_DIFFERENT_CHANNEL"] = "used_different_channel";
    NotInterestedReason["LONG_TERM_UNWANTED"] = "long_term_unwanted";
    NotInterestedReason["DEVELOPMENT_IMPOSSIBLE"] = "development_impossible";
    NotInterestedReason["DETAILS_DONT_MATCH"] = "details_dont_match";
    NotInterestedReason["OTHER"] = "other";
})(NotInterestedReason = exports.NotInterestedReason || (exports.NotInterestedReason = {}));
